console.log("Comparison Engine Loaded");

function isComparisonRequest(message){

    message = message.toLowerCase();

    return (

        message.includes("compare") ||

        message.includes("comparison") ||

        message.includes("difference") ||

        message.includes("different") ||

        message.includes("vs") ||

        message.includes("versus") ||

        message.includes("better") ||

        message.includes("which is better") ||

        message.includes("which one is better")

    );

}

function detectComparisonCategories(message){

    message = message.toLowerCase();

    const found = [];

    const categories = {

        "bulb camera":"bulb_camera",

        "outdoor camera":"outdoor_camera",

        "ptz camera":"ptz_camera",

        "indoor camera":"indoor_camera",

        "fingerprint lock":"fingerprint_lock",

        "smart lock":"fingerprint_lock"

    };

    for(const text in categories){

        if(message.includes(text)){

            found.push(categories[text]);

        }

    }

    return [...new Set(found)];

}

function generateCategoryComparison(categories){

    if(categories.length < 2){

        return null;

    }

    const first = CATEGORY_COMPARISON[categories[0]];

    const second = CATEGORY_COMPARISON[categories[1]];

    if(!first || !second){

        return null;

    }

    let html = "";

    html += "<h3>📊 AI Product Comparison</h3>";

    html += "<table class='assistant-comparison-table'>";

    html += "<tr>";

    html += "<th>Feature</th>";

    html += "<th>"+first.title+"</th>";

    html += "<th>"+second.title+"</th>";

    html += "</tr>";

    html += "<tr>";

    html += "<td>Installation</td>";

    html += "<td>"+first.installation+"</td>";

    html += "<td>"+second.installation+"</td>";

    html += "</tr>";

    html += "<tr>";

    html += "<td>Coverage</td>";

    html += "<td>"+first.coverage+"</td>";

    html += "<td>"+second.coverage+"</td>";

    html += "</tr>";

    html += "<tr>";

    html += "<td>Outdoor</td>";

    html += "<td>"+first.outdoor+"</td>";

    html += "<td>"+second.outdoor+"</td>";

    html += "</tr>";

    html += "<tr>";

    html += "<td>Wi-Fi</td>";

    html += "<td>"+first.wifi+"</td>";

    html += "<td>"+second.wifi+"</td>";

    html += "</tr>";

    html += "<tr>";

    html += "<td>Night Vision</td>";

    html += "<td>"+first.nightVision+"</td>";

    html += "<td>"+second.nightVision+"</td>";

    html += "</tr>";

    html += "<tr>";

    html += "<td>Best For</td>";

    html += "<td>"+first.bestFor+"</td>";

    html += "<td>"+second.bestFor+"</td>";

    html += "</tr>";

    html += "</table>";

    return html;

}

function extractComparisonCategories(message){

    message = message.toLowerCase();

    //---------------------------------------
    // Normalize sentence
    //---------------------------------------

    message = message
        .replace("difference between", "")
        .replace("compare", "")
        .replace("which is better", "")
        .replace("which one is better", "")
        .replace("better", "")
        .replace("versus", "vs");

    //---------------------------------------
    // Detect categories
    //---------------------------------------

    return detectComparisonCategories(message);

}